import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';

@Injectable()
export class OrderStartReviewService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderStartReview(orderId: string, skipReview: boolean): Observable<any> {
        return this.http.post<any>(
            `${this.environment.api}orders/${orderId}/startReview?skipReview=${skipReview}`,
            {
                id: orderId
            }
        );
    }
}
